<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con">
<div class="chapterHead">
<a id="page06"></a>
<a id="page07"></a>
<h2 class="contentsHead"><span class="bold"><em class="italic">Contents</em></span></h2></div>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName"><em class="italic"><a href="#/ack01#ack01">Acknowledgements</a></em></p></div>
<div class="contentsEntry1" id="map_01">
<p class="contentsEntryName"><em class="italic"><a href="#/map01#map01">Map</a></em></p></div>
<div class="contentsEntry1" id="int_01">
<p class="contentsEntryName"><em class="italic"><a href="#/int01#int01">Introduction</a></em></p></div>
<br/>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><span class="bold"><a href="#/ch01#ch01">CHAPTER ONE</a></span></p>
<p class="contentsEntryName"><em class="italic"><a href="#/ch01#ch01">You can check out any time you like, <br/>but you can never leave</a></em></p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch02#ch02" title="Link target outside of Sample">CHAPTER TWO</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch02#ch02" title="Link target outside of Sample">Plaything for a king</span></em></p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch03#ch03" title="Link target outside of Sample">CHAPTER THREE</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch03#ch03" title="Link target outside of Sample">Birth of the Leopard</span></em></p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch04#ch04" title="Link target outside of Sample">CHAPTER FOUR</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch04#ch04" title="Link target outside of Sample">Dizzy worms</span></em></p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch05#ch05" title="Link target outside of Sample">CHAPTER FIVE</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch05#ch05" title="Link target outside of Sample">Living above the shop</span></em></p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch06#ch06" title="Link target outside of Sample">CHAPTER SIX</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch06#ch06" title="Link target outside of Sample">A nation on Low Batt</span></em></p></div>
<a id="page08"></a>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch07#ch07" title="Link target outside of Sample">CHAPTER SEVEN</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch07#ch07" title="Link target outside of Sample">Never naked</span></em></p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch08#ch08" title="Link target outside of Sample">CHAPTER EIGHT</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch08#ch08" title="Link target outside of Sample">The importance of being elegant</span></em></p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch09#ch09" title="Link target outside of Sample">CHAPTER NINE</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch09#ch09" title="Link target outside of Sample">I get by with a little help from my friends</span></em></p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch10#ch10" title="Link target outside of Sample">CHAPTER TEN</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch10#ch10" title="Link target outside of Sample">A folly in the jungle</span></em></p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch11#ch11" title="Link target outside of Sample">CHAPTER ELEVEN</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch11#ch11" title="Link target outside of Sample">The night the pink champagne went flat</span></em></p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch12#ch12" title="Link target outside of Sample">CHAPTER TWELVE</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch12#ch12" title="Link target outside of Sample">The Inseparable Four</span></em></p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch13#ch13" title="Link target outside of Sample">CHAPTER THIRTEEN</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch13#ch13" title="Link target outside of Sample">Nappies on the floor</span></em></p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span class="bold"><span href="#/ch14#ch14" title="Link target outside of Sample">CHAPTER FOURTEEN</span></span></p>
<p class="contentsEntryName"><em class="italic"><span href="#/ch14#ch14" title="Link target outside of Sample">Ill-gotten gains</span></em></p></div>
<br/>
<div class="contentsEntry1" id="epi_01">
<p class="contentsEntryName"><em class="italic"><span href="#/epi01#epi01" title="Link target outside of Sample">Epilogue</span></em></p></div>
<div class="contentsEntry1" id="glo_01">
<p class="contentsEntryName"><em class="italic"><span href="#/glo01#glo01" title="Link target outside of Sample">Glossary</span></em></p></div>
<div class="contentsEntry1" id="bib_01">
<p class="contentsEntryName"><em class="italic"><span href="#/bib01#bib01" title="Link target outside of Sample">Bibliography</span></em></p></div>
<div class="contentsEntry1" id="ind_01">
<p class="contentsEntryName"><em class="italic"><span href="#/ind01#ind01" title="Link target outside of Sample">Searchable Terms</span></em></p></div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><em class="italic"><span href="#/ata01#ata01" title="Link target outside of Sample">About the Author</span></em></p></div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><em class="italic"><span href="#/cop01#cop01" title="Link target outside of Sample">Copyright</span></em></p></div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><em class="italic"><span href="#/atp01#atp01" title="Link target outside of Sample">About the Publisher</span></em></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?26a6178b